import { Button, Drawer, Stack } from '@mui/material'
import { FC } from 'react'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import LoadingContent from 'src/features/masters/components/LatestBatchJobStatusDrawer/components/LoadingContent/LoadingContent'
import NotFoundContent from 'src/features/masters/components/LatestBatchJobStatusDrawer/components/NotFoundContent/NotFoundContent'
import { gray } from 'src/features/muikds/kdsColors'
import MasterBatchJobDetailsContent from './MasterBatchJobDetailsContent'
import { useMasterLatestBatchJobStatusDrawer } from './hooks/useMasterLatestBatchJobStatusDrawer'

type Props = {
  masterUuid: string
  open: boolean
  closeDrawer: () => void
}

const MasterLatestBatchJobStatusDrawer: FC<Props> = ({
  masterUuid,
  open,
  closeDrawer,
}) => {
  const { data, isLoading, isNotFound } = useMasterLatestBatchJobStatusDrawer(
    masterUuid,
    open,
  )

  const renderContent = () => {
    if (isLoading) return <LoadingContent />
    if (isNotFound) return <NotFoundContent />
    if (data)
      return (
        <MasterBatchJobDetailsContent masterUuid={masterUuid} data={data} />
      )
    return null
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      sx={{ '& .MuiDrawer-paper': { width: '600px' } }}
    >
      <Header>
        <HeaderTitle title="一括処理状況の確認" />
      </Header>

      <Stack sx={{ height: '100%' }}>
        {renderContent()}

        <Stack
          direction="row"
          justifyContent="flex-end"
          padding={3}
          sx={{
            borderTop: 1,
            borderColor: 'divider',
            backgroundColor: gray[2],
          }}
        >
          <Button variant="contained" color="secondary" onClick={closeDrawer}>
            閉じる
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  )
}

export default MasterLatestBatchJobStatusDrawer
